import { render, staticRenderFns } from "./dropdownMul.vue?vue&type=template&id=5b5732bc&"
import script from "./dropdownMul.vue?vue&type=script&lang=js&"
export * from "./dropdownMul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports